import React from "react";
import { CircularProgress, ButtonProps } from "@material-ui/core";
import { StyledButton, buttonTypes, useStyles } from "./styles";

export default function CobeeButton({
  styleType = "primary",
  isLoading = false,
  iconColor = undefined,
  className = "",
  disabled = undefined,
  children = undefined,
  ...rest
}: ButtonProps & {
  styleType?: string;
  isLoading?: boolean;
  iconColor?: string;
}): JSX.Element {
  const { spinner } = useStyles();
  const buttonStyles = buttonTypes({ iconColor });
  return (
    <StyledButton
      {...rest}
      className={`${
        styleType !== "iconOnlySecondary" && buttonStyles.default
      } ${buttonStyles[styleType]} ${className}`}
      disableRipple
      disabled={disabled || isLoading}
      variant={styleType === "primary" ? "contained" : "outlined"}
    >
      {isLoading && <CircularProgress className={spinner} size={16} />}
      {children}
    </StyledButton>
  );
}
